// =============================================================================
// Puts the Cut & Crimp mark in the header.
//
// Horizon builds the logo from blocks/_header-logo.liquid, which renders
//
//   <a class="header-logo" href="/">
//     <span class="header-logo__image-container ..." data-testid="header-logo">
//       ... settings.logo, or shop.name as a text fallback ...
//
// With no logo image set that span holds the shop name as plain text. This
// swaps that text for the real lockup, which snippets/cc-brand.liquid has
// already put in the document as an inert <template>.
//
// The artwork is cloned rather than built here on purpose: it stays readable
// and editable as markup in the snippet, and there is no SVG hidden in JS
// string literals for the next person to find.
//
// Nothing is passed in through data attributes. The accessible name lives on
// the SVG in the template, set from shop.name by Liquid.
//
// Written to fail silently and leave the theme alone if it cannot find what
// it expects. A header showing the shop name in the body face is a worse
// header; a header thrown into an exception is a broken site.
// =============================================================================

(function () {
  "use strict";

  function brand() {
    var tpl = document.getElementById("cc-lockup-source");
    if (!tpl || !("content" in tpl)) return;

    // data-testid is the stable hook here. Horizon may rename its classes in
    // an update; test ids are contract-ish and survive that.
    var targets = document.querySelectorAll('[data-testid="header-logo"]');
    if (!targets.length) {
      var fallback = document.querySelector("a.header-logo");
      targets = fallback ? [fallback] : [];
    }

    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (el.getAttribute("data-cc-branded") === "true") continue;
      // If a real logo image has been set in theme settings since, that is a
      // deliberate choice by whoever set it. Leave it alone.
      if (el.querySelector("img, svg.cc-lockup")) continue;

      el.textContent = "";
      el.appendChild(tpl.content.cloneNode(true));
      el.setAttribute("data-cc-branded", "true");
    }
  }

  try {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", brand, { once: true });
    } else {
      brand();
    }
    // The theme editor re-renders sections in place without a page load.
    document.addEventListener("shopify:section:load", brand);
  } catch (err) {
    console.error("[cc-brand]", err);
  }
})();
